import React from 'react';
import { Link } from 'react-router-dom';
import { Label } from '_atoms/Typography/Typography';
import { TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { ReactComponent as BreadArrow } from 'dist/icons/Vector1.svg';
import type { BreadCrumbsProps } from './types';
import './breadCrumbs.scss';

type LinkComponent = React.ComponentType<{ to: string; className?: string; children?: React.ReactNode }>;
const RouterLink = Link as LinkComponent;

export const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ path, element, elementName, crumbs = [] }) => (
  <div className="bread-crumbs__wrapper">
    <div className="bread-crumbs">
      <RouterLink className=" bread-crumbs_element" to={path}>
        {element}
      </RouterLink>
      {crumbs.map(crumb => (
        <React.Fragment key={crumb.path}>
          <BreadArrow className="bread-crumbs_arrow" />
          <RouterLink className=" bread-crumbs_element" to={crumb.path}>
            {crumb.label}
          </RouterLink>
        </React.Fragment>
      ))}
      <BreadArrow className="bread-crumbs_arrow" />
      <Label className=" bread-crumbs_name" weight={TYPOGRAPHY_WEIGHT.NORMAL}>
        {elementName}
      </Label>
    </div>
  </div>
);
